import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';
import { Modal } from 'react-bootstrap';
import { useRollbackOperationModal } from '../context/RollbackOperationModalContext';

const RollbackOperationModalFooter: FC = () => {
  const { t } = useTranslate();
  const { data, actions } = useRollbackOperationModal();

  return (
    <>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-lg btn-danger"
          onClick={actions.handleRollbackOperation}
          disabled={!data.isRollBackConfirmed || data.isRollbackDisabled}
        >
          {t('RollbackOperation')}
        </button>
      </Modal.Footer>
    </>
  );
};

export default RollbackOperationModalFooter;
